export interface Profile {
  access_rights: number[];
  profile_id: number;
  profile_name: string;
}

export class Profile implements Profile {}
